var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('div',{staticClass:"avatar circle",class:{'big-avatar':_vm.big},style:({'background-image': `url(${_vm.url})`})}):_c('div',{staticClass:"avatar circle",class:{'big-avatar':_vm.big}})
}
var staticRenderFns = []

export { render, staticRenderFns }